export default __webpack_public_path__ + "static/media/Add-to-Cart.340c8d9f.svg";